import React from 'react'
import { Layout, Menu, Button, message } from 'antd'
import { withRouter } from 'react-router-dom'
import { axiosPost } from '../../server/index'
import { getCookie } from '../../public/utils'
import common from '../../public/common'
const { Header, Sider, Content } = Layout
const eurekaUrl = common.eurekaUrlDic + 'oms/'
class EmptyPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  applyLimit=async () => {
    this.setState({
      loading: true
    })
    axiosPost(eurekaUrl + 'ums/permission/email', {
      username: getCookie('login_username'),
      menuname: window.localStorage.getItem('menuname')
    }).then(res => {
      if (res.status === 200) {
        message.success('申请成功，请耐心等待审批')
        this.setState({
          loading: false
        })
      }
    })
  }
  render () {
    return (
      <div style={{fontSize: '20px', marginTop: '200px', textAlign: 'center'}}>您暂时无法访问，请联系采购员开通权限

      </div>
    )
  }
}
export default EmptyPage



// WEBPACK FOOTER //
// ./src/pages/emptyPage/emptyPage.js